"use client";

import { useState, useEffect } from "react";

export default function GoToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      // Lower threshold for mobile devices
      const threshold = window.innerWidth <= 768 ? 200 : 300;
      if (window.pageYOffset > threshold) {
        if (!isVisible) {
          setHasAnimated(false);
        }
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Initial check
    toggleVisibility();

    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("resize", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-[9999] bg-[#1a5852] hover:bg-[#0f3d37] text-white p-3 sm:p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-500 ease-in-out hover:scale-110 focus:outline-none focus:ring-4 focus:ring-[#1a5852] focus:ring-opacity-30 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center transform ${
        isVisible 
          ? `opacity-100 scale-100 translate-y-0 ${!hasAnimated ? '' : 'animate-pulse'} shadow-[0_0_20px_rgba(26,88,82,0.3)]` 
          : 'opacity-0 scale-75 translate-y-4 pointer-events-none'
      }`}
      onAnimationEnd={() => setHasAnimated(true)}
      aria-label="Go to top"
      title="Go to top"
    >
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </button>
  );
}
